import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing exclusion list entries.
 * F-022: Member Exclusion Lists - CRUD operations for individual entries.
 */
@Injectable({
    providedIn: 'root'
})
export class ExclusionListEntryService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/exclusionListEntries')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-ban';
    }
}
